import React from 'react';

import { appRoutes } from '@clearverify/constants';

import { DEFAULT_AVATAR } from 'src/assets';
import { BaseLayoutHeader, LeftMenuLogo } from 'src/components/common';
import { BREADCRUMBS } from 'src/constants/breadcrumbs';
import { InboxItemTitleMap } from 'src/constants/inbox';
import { useScreenInfo } from 'src/hooks/common';
import { useInboxItemById, useInboxItemParamId } from 'src/hooks/inboxItem';
import { useGlobalState } from 'src/hooks/shared';
import { useCurrentUser, useUserAvatar } from 'src/hooks/user';

export const LayoutHeader: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();
  const { isMobile } = useScreenInfo();
  const inboxItemId = useInboxItemParamId();
  const { inboxItem, loading } = useInboxItemById(inboxItemId);

  const { user } = useCurrentUser();
  const { userAvatar } = useUserAvatar(user?.id);

  return (
    <BaseLayoutHeader
      rootRoute={appRoutes.inbox.index}
      logoutRoute={appRoutes.auth.logout}
      currentUser={user}
      currentUserAvatarUrl={userAvatar?.downloadUrl}
      defaultLogoUrl={DEFAULT_AVATAR}
      leftMenuDrawerState={leftMenuDrawerState}
      breadCrumbs={BREADCRUMBS}
      accountRoute={appRoutes.account.index}
      leftLogo={isMobile ? <LeftMenuLogo /> : null}
      inboxItemTypeTitle={inboxItem?.type ? InboxItemTitleMap[inboxItem.type] : undefined}
      loadingPageTitle={!!inboxItemId && loading}
    />
  );
};
